export default [
  {
    path: '/mercado/:idProduto?',
    name: 'mercado',
    component: () => import(/* webpackChunkName: "mercado" */ '../../views/produtos/Mercado')
  }
]
